{
  "error": "Error",
  "try_again": "Please try again",
  "welcome": "Welcome",
  "version": "Version",
  "error_network_request_failed": "Connection error",
  "error_check_internet": "Please check your Internet connection.",
  "login": "Login",
  "logout": "Logout",
  "cancel": "Cancel",
  "ok": "OK",
  "yes": "Yes",
  "no": "NO",
  "password": "Password",
  "e-mail": "Email",
  "error_login_failed": "Login failed",
  "skip": "skip",
  "error_no_connection_to_server": "No connection to server.",
  "step": "Step",
  "not_available": "Not available",
  "error_could_not_save_reservation": "Could not save booking.",
  "error_problem_with_reservation": "There was a problem with the booking.",
  "rent_now": "Book now",
  "check_again": "Check again",
  "messages": "Messages",
  "message_draft": "Draft",
  "message_sent": "Sent",
  "message_success": "Success",
  "message_paused": "Paused",
  "message_failed": "Failed",
  "message_trash": "Trash",
  "message_scheduled": "Scheduled",
  "success": "Success",
  "recipient": "Recipient",
  "close multiple recipients dialog": "Close multiple recipients dialog",
  "open profile": "Open profile",
  "multiple": "Multiple",
  "service": "Service",
  "error_general_error": "An error occurred!",
  "error_try_again": "An error occurred, please try again.",
  "No device token": "No device token",
  "end": "End",
  "end_now": "End now",
  "hi": "Hi",
  "bye": "Bye",
  "english": "English",
  "german": "German",
  "loading": "Loading",
  "created_date": "Created on",
  "created_at": "Created at",
  "enter some contents in here": "Enter some contents in here...",
  "message_nbr": "Message_nbr",
  "subject": "Subject",
  "notification": "Notification",
  "to": "To",
  "list of recipients must have at least 1 item": "List of recipients must have at least 1 item",
  "enter a subject": "Enter a subject",
  "choose recipients...": "Choose recipients...",
  "choose type of recipient": "Choose type of recipient",
  "choose type of notification": "Choose type of notification",
  "userID": "User ID",
  "userGroup": "Usergroups ID",
  "allUsers": "All",
  "toast": "Toast message",
  "popup": "Popup",
  "draft": "Draft",
  "send": "Send",
  "scheduled": "Scheduled",
  "sent": "Sent",
  "content": "Content",
  "message_status": "Status",
  "more": "More",
  "schedule for later": "Schedule for later",
  "last_modified_at": "Last modified on",
  "remove": "Remove",
  "dashboard": "Dashboard",
  "fleet": "Contingents",
  "users": "User",
  "username": "User name",
  "send message": "Send Message",
  "my_inbooma": "My Inbooma",
  "reservation": "Booking",
  "orders": "Orders",
  "toggle_${a}_view": "Open ${a} view.",
  "user ${a} added to recipient field, please add another user": "User ${a} added to recipient field, please add another user",
  "user group ${a} added to recipient field, please add another user group": "User group ${a} added to recipient field, please add another user group",
  "user ${a} does not exist, please enter a valid user": "User ${a} does not exist, please enter a valid user",
  "user group ${a} does not exist, please enter a valid user group": "User group ${a} does not exist, please enter a valid user group",
  "subject of message is required": "Subject of message is required",
  "type of recipient is required and must be one of the following values: userID, userGroup, allUsers": "Type of recipient is required and must be one of the following values: userID, userGroup, allUsers",
  "display of notification is required and must be one of the following values: toast, popup": "Display of notification is required and must be one of the following values: toast, popup",
  "display": "Display",
  "list of recipients is required": "List of recipients is required",
  "content of message is required": "Content of message is required",
  "must be positive": "Must be positive",
  "delete message successfully": "Delete message successfully",
  "delete message unsuccessfully": "Delete message unsuccessfully",
  "schedule recurrence must be one of the following values: day, week, month, year": "Schedule recurrence must be one of the following values: day, week, month, year",
  "click to remove this recipient": "Click to remove this recipient",
  "list": "List",
  "calendar": "Calendar",
  "customer": "User",
  "contingent": "Contingent",
  "order": "Order",
  "id": "ID",
  "repeat": "Repeat",
  "repeat every": "Repeat every",
  "day": "Day",
  "week": "Week",
  "month": "Month",
  "year": "Year",
  "notifications": "notifications",
  "sms": "Sms",
  "push": "Push",
  "schedule send": "Schedule send",
  "pick date & time": "Pick date & time",
  "close schedule dialog": "Close schedule dialog",
  "new_${a}": "New ${a}",
  "edit_${a}": "Edit ${a}",
  "send_${a}": "Send ${a}",
  "toggle_${a}": "Toggle ${a}",
  "open_filter_menu": "Open filter menu",
  "confirmed": "Confirmed",
  "name": "Name",
  "location": "Location\n",
  "description": "Description",
  "open": "open",
  "resource": "Resource",
  "close_window": "Close window",
  "list_of_locations": "List of locations",
  "no_locations_yet": "You have not added any locations yet.",
  "declined": "declined",
  "no_linked_reservations": "No linked bookings",
  "linked_reservations": "Linked bookings",
  "edit": "Edit",
  "delete": "Remove",
  "date": "Date",
  "object": "Object",
  "nights": "Nights",
  "status": "Status",
  "price": "Price",
  "staff": "Staff",
  "all": "All",
  "upcoming": "Upcoming",
  "past": "Past",
  "dates": "Dates",
  "valid_from": "from",
  "valid_to": "to",
  "paystate": "Pay status",
  "resourcetype": "Type",
  "paid": "Paid",
  "partly_paid": "Partially paid",
  "unpaid": "Not paid",
  "cancel_reservation": "Cancel",
  "back_to_overview": "Back to overview",
  "quick_actions": "Perform actions",
  "filter_by_role": "Filter by role",
  "role": "Role",
  "role_admin": "Administrator",
  "user": "User",
  "role_user": "User",
  "role_client": "Customer",
  "role_superadmin": "Superadmin",
  "user_role": "User role",
  "user_sidebar_tip_box": "Set up or configure roles to ensure your data stays safe.",
  "active": "active",
  "inactive": "inactive",
  "defect": "damaged",
  "save": "Save",
  "contingents": "Contingents",
  "change_language": "Change language",
  "no_linked_resources": "No linked resources",
  "linked_resources": "Linked resources",
  "battery_condition": "Battery condition",
  "open_external_link": "Open external link",
  "mac_adress": "Lock ID",
  "vehicles_active": "Vehicle(s) available",
  "contingent_name": "Contingent name",
  "resources_amount": "Amount of resources",
  "autogenerate_resources": "Automatically generate resources?",
  "start": "Start",
  "add_${a}": "Add ${a}",
  "contingent_label": "Contingent label",
  "linked_orders": "Orders",
  "manage_roles": "Manage roles",
  "box": "Box",
  "select_user_role": "Select user role",
  "user_title": "Title",
  "user_title_mr": "Mr.",
  "user_title_mrs": "Ms.",
  "first_name": "First name",
  "last_name": "Last name",
  "user_active": "Active user?",
  "longitude": "Longitude",
  "latitude": "Latitude",
  "geofence": "Geofence",
  "order_nbr": "Order no.",
  "open_profile": "Open profile",
  "appointment": "Date",
  "appointments": "Dates",
  "adult": "Adult",
  "adults": "Adults",
  "child": "Child",
  "children": "Children",
  "save_${a}": "Save ${a}",
  "total_price": "Total price",
  "updated_${a}": "${a} updated",
  "user_info_after_save": "If an email address was provided, we will send a confirmation email including the user's password after submitting.",
  "choose_existing_customer": "Choose an existing customer",
  "add_${a}_first": "Add ${a} first",
  "select_element": "Select element",
  "send_feedback": "Send feedback",
  "profile": "Profile",
  "reservations": "Bookings",
  "selected_${a}": "${a} selected",
  "delete_${a}": "Delete ${a}",
  "change_status_to": "Change status to",
  "required": "required",
  "reservation_status": "Order Status",
  "requested": "requested",
  "admin": "Administrator",
  "save_next_step": "Save &amp; got to next step",
  "vehicle_inactive": "Vehicle(s) inactive",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "sunday": "Sunday",
  "event_title": "Event title",
  "single_appointment": "Single appointment",
  "recurring_appointment": "Recurring appointment",
  "repeat_every_after": "Repeat every",
  "week(s)": "week(s)",
  "month(s)": "month(s)",
  "year(s)": "year(s)",
  "optional": "optional",
  "till": "to",
  "really_remove": "Do you really want to make this change?",
  "recurring": "recurring",
  "reschedule_appointment": "Reschedule appointment",
  "o_clock": "o'clock",
  "form_validation_error": "Validation error - please fill out all highlighted fields properly.",
  "request_error": "Server error - please try later or inform the administrator.",
  "filter_selected": "Selected filter",
  "prices": "Prices",
  "radius_in_meter": "Radius in meters",
  "no_contingents_yet": "No contingents",
  "app_msg_page_not_found": "Page not found.",
  "app_msg_page_not_found_body": "Would you like to <a href=\"#\" onclick=\"javascript:window.history.back();return false;\">go back a step</a>?",
  "app_msg_collection_empty": "No results found.",
  "app_msg_collection_empty_body": "Clear filters or add new data.",
  "app_msg_access_error": "Access denied.",
  "app_msg_access_error_body": "Your role does not have access to this section.",
  "app_msg_error": "Houston, we have a problem...",
  "app_msg_error_body": "Please check your internet connection or try <a href=\"#\" onclick=\"javascript:window.location.reload();return false;\">reloading this page</a>.",
  "manager": "Manager",
  "role_manager": "Manager",
  "app_msg_orders_intro": "Orders &amp; bookings",
  "app_msg_orders_intro_body": "Multiple related bookings from one customer can be bundled in one order. This allows for clearer invoices and payments.",
  "app_msg_orders_intro_action": "<strong>Select a customer</strong> to go to the next step. <a href=\"#\" class=\"hide close-callout\">Do not show again.</a>",
  "saved_${a}": "${a} saved",
  "saved": "Saved",
  "autogenerate_resources_body": "Adds bookable resources to the contingent (recommended)",
  "participants_amount": "Number of participants",
  "removed_${a}": "${a} deleted",
  "resource_secret": "Secret code",
  "action_logged_out": "You have been logged out successfully.",
  "action_logged_out_expired_token": "Your session expired.",
  "customers": "Customer",
  "created": "created",
  "empty_locations_teaser_body": "After adding a location, it can be linked with multiple contingents.",
  "locations": "Locations",
  "max_${a}_pers": "max. ${a} persons",
  "select_${a}": "select ${a}",
  "reset_filter": "Clear filter",
  "notes": "Notes",
  "no_special_char_allowed": "At least At least 3 characters;",
  "reservation_error_missing_begin": "Missing start value.",
  "reservation_error_missing_end": "Missing end value.",
  "invalid_time_format": "Invalid time format",
  "reservation_error_start_bigger_than_end": "The end value must be later than the start value.",
  "app_msg_empty_order": "No bookings have been added to this order so far.",
  "user_error_unique_username": "This user name already exists.",
  "user not found": "User not found",
  "please add user to this group": "Please add user to this group",
  "you can only send notification to one usergroup": "You can only send notification to one usergroup",
  "completed": "Completed",
  "added_${a}": "${a} added",
  "app_msg_contingents_intro": "Contingents &amp; Resources",
  "app_msg_contingents_intro_body": "Contingents can be bikes, cars, appointments or other bookable entities that have a maximum number of available slots. If your Inbooma account has an App plan, you may convert these amounts into real resources and add device IDs, names and tracking info.",
  "app_msg_users_intro": "Customer &amp; Staff Management",
  "app_msg_users_intro_body": "Each of your users will appear in this list and can be managed from here. New users can be assigned a role of <strong>administrator, manager or customer/user</strong>.",
  "user_registration_mail_sent": "A registration email was sent to the new user.",
  "change_bookable_resources": "Change bookable resources",
  "number_total": "Total number",
  "number_active": "Bookable resources",
  "action_welcome_successfully_registered": "Welcome to Inbooma! You have successfully been registered.",
  "appointments_error_no_contingent": "Found no contingent of type \"appointment\". Create now?",
  "day_on": "on",
  "reservations_error_no_contingents": "No contingents found. Would you like to create one now?",
  "abort": "cancel",
  "reservation_ended_not_editable": "Booking status not changeable as the booking has already been completed.",
  "contingent_warning_too_less_total": "Warning: More resources have been created than named in the contingent. Please increase the total number by clicking the orange bar below.",
  "tour_in_progress": "Tour in progress",
  "app_order_bike_tour_${a}": "Booking via App (${a} x 1)",
  "user_title_family": "Family",
  "user_title_company": "Company",
  "order_successfully_executed": "An email including all booking information was sent to the user.",
  "execute_order": "Confirm order",
  "order_executed_at": "Order confirmation sent on",
  "user_error_unique_mail": "This email address is already in use",
  "execute_order_body": "Send 'order confirmation' email",
  "submit_order_status": "Send order status",
  "submit_order_status_body": "Send 'order status' email",
  "order_status_successfully_submitted": "An email with the current order status was sent to the user.",
  "user_activcurrentTargete_body": "Only active users can log in.",
  "create_ics": "ICS file",
  "create_ics_all_orders": "Create ICS file for all orders",
  "resource_not_configured_yet": "Resource unconfigured",
  "location_error_geofence_number": "The geofence value must be a number.",
  "street": "Street",
  "house_nbr": "House number",
  "zip": "Post code",
  "city": "Postcode City",
  "phone_nbr": "Phone number",
  "repeat_password": "Repeat password",
  "register": "register",
  "registration": "Registration",
  "deleted_resource": "Resource deleted",
  "pricetype": "Price type",
  "pricetypes": "Price types",
  "pricetariff": "Price tariff",
  "pricetariffs": "Price tariffs",
  "price_standard": "Standard",
  "warning_prices_not_complete": "Warning: Not all weekdays have a price. Would you like to continue?",
  "price_total": "Total price",
  "reservation_error_no_pricetariffs_for_${a}": "No prices have been defined for this contingent. <a href=\"/contingents/${a}/prices\">Add tariffs.</a>",
  "price_error_select_values_first": "Set contingent, start and end values to calculate price.",
  "price_error_fetch": "Houston, we have a problem... Please try again later.",
  "price_error_no_prices_found_for_tariff": "No prices could be found for this tariff.",
  "reschedule": "Change time",
  "${a}_of_${b}_booked": "${a} of ${b} places booked",
  "calendars_info_text": "Calendars help you to group together similar kinds of \"appointment\" contingents. Once you have created a calendar, you can assign contingents to it and create events.",
  "remove_contingent_from_calendar": "Remove contingent from calendar",
  "calendars": "Calendar",
  "close_notification": "Close notification",
  "prices_begin_info": "Start of price period",
  "prices_end_info": "End of price period",
  "locations_description_field_info": "e.g. \"near S-Bahn station\"",
  "price_default_info": "Leave this field empty if your prices vary from weekday to weekday.",
  "toggle_event_blocked": "Block event / remove block",
  "confirm_set_blocking": "Do you really want to block this event?",
  "event_confirm_unset_blocking": "Do you really want to unblock this event?",
  "event_set_blocking": "This event was blocked.",
  "event_removed_blocking": "This event is bookable again.",
  "unset_reschedule": "Reset changes",
  "success_saved_rescheduling": "The event was updated.",
  "success_removed_rescheduling": "The event was updated.",
  "select_appointment": "Select appointment",
  "person_s": "Person(s)",
  "C_6_fleet": "Contingents",
  "error_events_found_no_calendar": "You have not yet added a calendar to this contingent. Add contingent now?",
  "status_booking_process": "Tour in progress",
  "max_pers_count": "Max. number of participants",
  "max_pers_count_help": "The number of already booked participants may not be exceeded.",
  "open_link": "Open link",
  "dsgvo_accept_label": "I accept the privacy policy",
  "cancelled": "Cancelled",
  "inprogress": "Tour in progress",
  "inprogress_ext": "Booking in progress",
  "language": "Language",
  "payments": "Payments",
  "overview": "Overview",
  "finances": "Finances",
  "reference_id": "Reference ID",
  "price_origin_${a}": "Origin of payment: ${a}",
  "amount": "Amount",
  "account": "Bank account",
  "transactions": "Transactions",
  "we_charge_you_following_positions": "We will charge you for the following positions",
  "net": "net",
  "gross": "gross",
  "ust": "VAT",
  "ust_sentence": "VAT rate",
  "complete": "Invoice amount",
  "invoice_nbr": "Invoice number",
  "gesamt": "total",
  "check_payment": "mark as paid",
  "print": "print",
  "times": "Booked times",
  "includes": "including",
  "mwst": "VAT",
  "invoice": "Invoice",
  "invoice_for": "Invoice for",
  "create_invoice": "Create invoice",
  "check_your_inbox": "Thank you for your registration.",
  "a_confirmation_mail_was_sended": "An email confirming your registration has been sent to the provided email address. If not, please check your spam folder.",
  "welcome_to_inbooma": "Hello",
  "email_has_been_confirmed": "Your email address has been confirmed and your account is ready to go.",
  "login_now": "Login now",
  "username_to_short": "User name too short!",
  "stay_logged_in": "Stay logged in?",
  "reset_password": "Reset password",
  "forgot_password": "Change password",
  "made_width": "Made with",
  "mobile_app": "Mobile app",
  "please_enter_email": "Your Inbooma account email",
  "email_to_short": "Email address too short!",
  "next_step": "Next",
  "password_to_short": "Password too short!",
  "unknown_email_address": "Invalid or unknown email address!",
  "please_check_email": "Please check your email account for an activation email.",
  "back_to_login": "Back to login",
  "data_protection_agreement": "Data protection agreement",
  "order_cancelled_success_transactions": "A payment has already been posted for the cancelled order. This will not be refunded automatically.",
  "order_cancelled_success": "Order cancelled.",
  "payout_form": "Payout form",
  "confirm_payout": "Confirm payout",
  "payout_amount_help": "Please separate amounts with a dot, e.g. 120.30",
  "booking_activity": "Booking activity",
  "${a}_days": "${a} days",
  "payment_account": "Bank account",
  "payment_accounts": "Bank accounts",
  "payment_accounts_form": "Connect bank account",
  "account_holder_name": "Account owner",
  "account_iban_number": "IBAN",
  "account_iban_number_info": " ",
  "bank_code": "BIC",
  "bank_code_info": "optional",
  "cash": "cash",
  "credit_card": "credit card",
  "sepa": "SEPA",
  "pending": "pending",
  "payout": "paid",
  "refund": "refunded",
  "minimum_${a}_chars_required": "At least ${a} characters needed",
  "both_passwords_must_be_the_same": "Passwords do not match",
  "change_password": "Change password",
  "user_register_page": "Public registration page",
  "zip_code": "Post code",
  "email": "Email",
  "house_number": "House number",
  "notification_text": "Fields with * are mandatory",
  "agb_accept_label": "I accept the terms of use",
  "invalid_username_password": "Invalid user name or password",
  "contingent_location_help": "Resources can be checked in and returned here",
  "contingent_placeholder": "e.g. E-Bike standard size",
  "location_of_checkin": "Pick up station",
  "location_of_checkout": "Return station",
  "resource_start_location": "Start pick up station",
  "facilities": "Parking facilities",
  "facility": "Parking facilities",
  "slot": "Charging station",
  "error_code": "Error code",
  "error_text": "Error text",
  "facility_modified": "Last change",
  "linked_slots": "Charging station",
  "no_linked_slots": "No charging station",
  "closed": "Lock closed",
  "charging_quality": "Charging quality",
  "external_resource_id": "Company number (external resource ID)",
  "participants_bookable": "Participants bookable",
  "discount_in_percent": "Discount (in percent)",
  "location_yet_undefined": "Location unknown",
  "pricediscounts": "Discounts",
  "discount_type": "Discount type",
  "valid": "Valid",
  "user_discount": "Customer discount Customer discount",
  "client_discount": "Repeat booking discount",
  "pricediscount": "Discount",
  "app_msg_pricediscounts_intro": "Discounts",
  "app_msg_pricediscounts_intro_body": "With discounts it is possible for you to give your customers price reductions.",
  "discount_amount": "Discount (in �)",
  "user_discounts": "Customer discount",
  "client_discounts": "Repeat booking discount",
  "discount_percent": "Discount (in %)",
  "combineable": "Combineable",
  "count_units": "Amount",
  "booking_type": "Type",
  "phone_number": "Phone number",
  "country": "Country",
  "number_discounts": "Coupons",
  "number_discount": "Coupon",
  "discount_number": "Coupon code",
  "you_are_activated_after_registration": "Please wait until your registration is verified and your account is activated.",
  "cannot_remove_${a}": "You do not have the rights to remove ${a}.",
  "cannot_update_${a}_${b}": "For ${a} the role ${b} could not be set as you do not have the required rights.",
  "with_role_${r}": " With the role ${r} ",
  "number_slots": "Number of charging stations",
  "autogenerate_facility_slots": "Autogenerate charging station number",
  "autogenerate_facilities_body": "Charging stations will be generated according to the number field above",
  "make_payout": "Pay out",
  "title": "Title",
  "The provided value is invalid": "The entered value is invalid",
  "This value is already in use": "This value is already in use",
  "withdrawable_cash": "Payable",
  "transactions_of_${a}": "Transactions in ${a}",
  "client_account": "Main account",
  "user_account": "personal account",
  "payment_type": "payment type",
  "edit_profile": "Edit profile",
  "user_nbr": "Customer Nr.",
  "kunden_nbr": "Customer no.",
  "logged_in_as": "Logged in as",
  "username_${a}_role_${b}": "User name: ${a}, role: ${b}",
  "unselect_all_filter": "Remove all filters",
  "unselect_filter": "Remove filter",
  "contains_reservations_from": "Contains booking starting from",
  "contains_reservations_till": "Contains booking ending on",
  "my_account": "My account",
  "login_submit": "Login now",
  "open_order": "Open order",
  "domain_not_authorized": "Registration not possible / domain not authorised",
  "customer_removed": "User deleted",
  "price_from": "From",
  "load_more_title": "Click to load more content",
  "load_more": "Load more",
  "contingent_removed": "Contingent removed",
  "payout_success": "The payout was successful!",
  "payout_error_999": "Balance insufficient.",
  "duplicate": "duplicate",
  "duplicate_resource_info": "Copy resource and add it to contingent.",
  "duplicate_resource_success_${a}": "A new resource (#${a}) was added to the contingent.",
  "order_empty_remove": "This order has no linked bookings. Discard the order?",
  "one_location_required": "At least one location required",
  "appointment_blocked_not_bookable": "[Blocked; unbookable]",
  "payment_account_save_error": "Invalid BIC or IBAN",
  "Minimum eight characters, at least one uppercase letter, one lowercase letter and one number": "Minimum eight characters, incl. at least one uppercase letter, one lowercase letter and one number",
  "sort_by_${a}": "Sort by ${a}",
  "calendar_initializing": "Loading calendar...",
  "booking_time_differs": "Actual booking time differs",
  "begin_booking": "Check-in time",
  "end_booking": "Check-out time",
  "reservation_no_price": "No price",
  "new_password": "New password",
  "new_password_help": "At least 8 characters, one number, one uppercase and one lowercase letter",
  "new_password_confirm": "Confirm password",
  "new_password_submit": "Change password",
  "new_password_fill_out": "Fill out both password fields",
  "password_reset_identical": "Both password fields must be identical",
  "password_reset_invalid": "Password has to meet the validations",
  "new_password_success": "You've successfully changed your password!",
  "ordersForm": "Manage order",
  "unknown_or_removed_user": "Unknown or removed user",
  "succesfully_changed_password": "You've successfully changed your password!",
  "user_error_short_username": "Username must have at minimum 3 and at maximum 50 characters and must not contain special characters.",
  "email_format_not_valid": "Please enter a valid email address",
  "tarif": "Tariff",
  "tarifpreis": "Tariff price",
  "rabatt": "Discount",
  "mietpreis": "Rental price",
  "units_available": "Unit(s) selected",
  "add_unit": "Add unit",
  "no_discount_selected": "No discount selected",
  "action_conflict_less_selected_than_before": "You may lose prices that have already been configured",
  "action_unset_whole_contingent": "Previously configured prices will be lost",
  "warning_no_contingent_unit_available": "No units available at this time",
  "${a}_contingents_added": "${a} Unit(s) added",
  "${a}_contingents_deleted": "${a} Units(s) removed",
  "filter_by_contingent_name": "Search by name...",
  "notes_external": "Comment user/customer",
  "notes_internal": "Internal comment",
  "user_state_updated": "User status updated.",
  "select_unselect_contingent": "Click to select/reset quota",
  "opening_times_for": "Opening times for",
  "no_opening_times": "No opening times listed.",
  "form_validation_error_contingent_form": "Please select time, stations and contingents.",
  "a_password_reset_mail_was_sended": "A password reset email has been sent to your email address. If not, please check your spam folder.",
  "account_yet_unconfigured": "No account provided",
  "warning_reservation_in_progress": "Warning: Unsaved bookings are still open. Please save or cancel booking.",
  "in_days": "in days",
  "ruecktransport": "Return transport",
  "continue": "Next",
  "save_booking": "Create an order",
  "loading_return_stations_progress": "Load drop-off locations...",
  "no_return_station_found": "No drop-off locations found",
  "de_DE": "German",
  "en_GB": "English",
  "quick_form_step_1": "Order information",
  "quick_form_step_2": "User information",
  "role_manager-location": "Station manager",
  "add_existing_user": "Select existing user",
  "before_editing": "Before editing",
  "action_requires_booking_save": "Save booking to make changes effective.",
  "location_list_manager": "Location station manager",
  "location_list_manager_help": "Only required if 'Station Manager' role is selected.",
  "username_or_mail": "Email address or user name",
  "fr_FR": "French",
  "remove_booking_first_to_edit": "To change pick-up station, please delete existing booking and create a new one.",
  "Fahrzeuge": "Vehicles",
  "Bikesharing": "Bike sharing",
  "Termine": "Dates",
  "reservation_unsaved": "Unsaved",
  "user_has_newsletter": "Newsletter accepted",
  "user_privacy_accepted_yes": "Privacy policy accepted on",
  "user_privacy_accepted_no": "Privacy policy not yet accepted",
  "user_customer_nbr": "Member number",
  "valid_from_date": "Valid from/on",
  "no_contingents_available": "No contingents available",
  "add_empty_user": "Reset form",
  "checkin_reservation": "Check-in",
  "checkout_reservation": "Check-out",
  "checkin_search_placeholder": "Filter by name, ID or company number",
  "submit_checkin": "Complete check-in",
  "submit_checkout": "Complete check-out",
  "checked_in_contingents": "Checked-in contingents",
  "checkin_add_elements_to_cart": "Select resources from the list to add them to check-in.",
  "checkin_submit_error_empty": "Please add resources to the check-in list first.",
  "checkin_submit_success": "All selected resources have been successfully checked in. Booking is now in progress.",
  "checkout_submit_success": "All selected resources have been successfully checked out. Booking is now complete.",
  "checkin_remove_from_selection": "Remove from selection",
  "checkin_add_to_selection": "Check in resource",
  "checkin_comment_placeholder": "Submit comment",
  "checkout_comment_placeholder": "Remove comment",
  "checkin_resources_total": "Select",
  "checkin_resources_selected": "Selected",
  "checked_in_at": "Checked in on: ",
  "available": "Available",
  "voucher": "Coupon",
  "vouchers": "Coupons",
  "voucher_type": "Coupon type",
  "voucherTypes": "Coupon types",
  "voucher_types": "Coupon types",
  "voucher_type_discount": "Discount",
  "voucher_type_gift_card": "Gift certificate coupon",
  "voucher_unit": "Unit",
  "voucher_type_id": "Coupon no.",
  "voucher_unit_percentage": "Percent",
  "voucher_unit_fix_price": "Fixed price",
  "voucher_unit_contingent": "Contingent",
  "voucher_value": "Value",
  "voucher_value_is_nan": "Value is not a number",
  "vouchersForm": "Coupon form",
  "tab_discount": "Discount coupons",
  "tab_gift_card": "Gift certificate coupon",
  "multiple_use": "Redeemable more than once",
  "discount_vouchers": "Discount coupon",
  "type": "Type",
  "sellable": "Saleable",
  "unknown_or_removed_voucher": "Unknown or deleted",
  "voucher_codes": "Coupon codes",
  "voucher_codes_source": "Create codes",
  "voucher_codes_enter_as_text": "Enter codes",
  "voucher_codes_upload_file": "Upload file",
  "voucher_codes_generate": "Randomly generate",
  "voucher_codes_generate_count": "Number of codes",
  "voucher_codes_already_exist_${a}": "This code is already in use: ${a}",
  "codes_file": "Select file",
  "select_xlsx_file": "XLS/XLSX/CSV file",
  "enter_codes_separate_by": "seperate with ;",
  "code": "Code",
  "codes": "Codes",
  "no_voucher_type_selected": "-",
  "invalid_codes_${a}": "Invalid code: ${a}",
  "voucher_type_valid_to": "Valid until",
  "days_number": "max. number of days",
  "contingent_number": "Max. number of contingents",
  "voucher_codes_none": "-",
  "voucher_codes_new": "Add codes",
  "clone": "Duplicate",
  "school_bonus": "Discount for school groups",
  "add_payment": "Payments",
  "paymentList": "Payment summary",
  "ec_maestro": "EC/Maestro",
  "cheques": "Cheques",
  "payment_request": "Payment Request",
  "checkout_finished": "Check-out completed",
  "mietvertrag": "Rental agreement",
  "mietvertrag_help": "Download rental agreement for this booking.",
  "mietvertrag_download_error": "Rental agreement could not be created. Has the order already been processed?",
  "manual_override_help": "Reset overwritten price",
  "next_available_opening_time": "Open at the earliest from/on",
  "found_invalid_voucher": "Invalid coupon",
  "filter_locations_list": "Search locations...",
  "payment_success": "The payment information was saved.",
  "payment_error": "Error: The payment information was not saved",
  "checkin_state_pending": "Check-in pending",
  "checkin_state_checked_in": "Check-in completed",
  "checkin_state_checked_out": "Check-out completed",
  "today": "Today",
  "voucher_type_status_updated": "Voucher type status updated.",
  "contingent_empty": "No resource available",
  "edited_by": "from",
  "help": "Help",
  "daily_rental_contract": "Daily rental agreement",
  "rental_contract_type": "Rental agreement type",
  "rental_contract_type_normal": "Normal",
  "rental_contract_type_slowup": "Slowup",
  "rental_contract_error_empty": "No bookings available on this day",
  "rental_contract_error": "Rental agreement could not be created. Please try again later.",
  "rental_contract_warning": "Warning: Rental agreement is not up to date! Please reconfirm the order. Would you like to continue?",
  "order_not_confirmed_warning": "Changes to the order have not been confirmed yet!",
  "generate": "Generate",
  "for": "for",
  "user_active_body": "Only active users can log in.",
  "removed": "deleted",
  "user_added_to_order": "User was linked to new order.",
  "Datenschutzerkl�rung": "privacy policy",
  "pre_booking_time": "Early booking period",
  "units": "Units of time",
  "minutes": "minutes",
  "hours": "Hours",
  "days": "Days",
  "remove_booking_first": "The booking contains locations or contingents that have already been deleted and therefore cannot be edited.",
  "email_settings": "Email settings",
  "email_setting_get_booking_info": "Receive booking information if status changes",
  "user_no_mail_confirm": "No email address was entered. Would you like to continue?",
  "user_mail_adress_incomplete": "We recommend that you enter an email address.",
  "no_price_warning": "Warning: Tariff cannot be selected or k. Prices available.",
  "app_order_bike_tour_min_${a}": "Booking via App (${a})",
  "contingent_plans": "Contingent planning",
  "contingent_plan": "Contingent planning",
  "for_networks": "for network",
  "for_contingents": "for contingent(s)",
  "network_plan": "Network plan",
  "add_plan": "add",
  "hide_contingents": "hide",
  "show_contingents": "show",
  "external_resource_id_short": "Company number",
  "rental_contract_location": "rental contract for",
  "order_booking_state_sent_at": "Order status sent on",
  "push_changes": "Publish changes",
  "changes_success_notification": "Changes will be published in Online Booking frontend. This can take up to 5 mins until changes are displayed.",
  "changes_error_notification": "Failed to create task to publish changes to Online booking frontend.",
  "use_for": "To use for",
  "timespan": "Timespan",
  "start_time": "Start time",
  "end_time": "End time",
  "current_year": "Current year",
  "current_month": "Current Month",
  "last_year": "Last year",
  "last_month": "Last month",
  "filter_by_date": "Filter By Date",
  "filter_by_time": "Filter By Time",
  "filter_by_kilometer": "Filter By Kilometer",
  "filter_by_number": "Filter by Count of Rides",
  "filter_by_speed": "Filter by Maximum Speed",
  "filter_by_type": "Filter By Type",
  "speed": "Speed",
  "private": "Private",
  "business": "Business",
  "everyone": "Everyone",
  "fleet_statistics": "Fleet Statistics",
  "total_km": "Total sum of Km",
  "distance_per_booking": "Distance per Booking",
  "distance_per_bike": "Distance per Bike",
  "total_bookings": "Total number of Bookings",
  "median_km_per_booking": "Median - Km per Booking",
  "median_km_per_bike": "Median - Km per Bike",
  "bookings_per_usage_type_per_month": "Bookings per Booking Type per month",
  "bookings_per_mail_address_per_month": "Bookings per Membership per month",
  "total_bookings_per_month": "Total number of Bookings per month",
  "total_distances_per_month": "Total number of Distances per month",
  "bookings_per_usage_type": "Bookings per Booking Type",
  "distances_per_usage_type": "Distances per Booking Type",
  "users_per_mail_address": "Users per Membership",
  "bookings_per_mail_address": "Bookings per Membership",
  "carbonate_savings": "Carbonate Savings",
  "${a}_co2_savings_to_short_drives_norderstedt": "This is an equivalent of ${a} car rides in Norderstedt (distance < 10 km).",
  "${a}_co2_savings_to_norderstedt_luebeck": "This is an equivalent of ${a} car rides from Norderstedt to Lübeck (66 km).",
  "statistics": "Statistics",
  "charts": "Charts",
  "heatmap": "Heatmap",
  "no data available": "No data available",
  "open_lock": "Open lock",
  "close_lock": "Close Lock",
  "open_lock_warnig_${a}": "Are you sure to send the command \"${a}\"? Please make sure the lock has continous internet connection and enough battery. Should this and further commands fail, the lock may be closed manually.",
  "validPeriod": "validity of the login",
  "warning delete lock": "Warning! All lock data will be removed during save, the resource will no longer be bookable as bike. Are you sure?",
  "wrong_device_time_title": "Faulty device time",
  "wrong_device_time_msg": "The time on your device does not seem to be correct. Please check your date and time settings and enable automatic time setting if necessary.",
  "wrong_device_time_deviation": "Deviation",
  "wrong_device_time_current": "Current time",
  "wrong_device_time_device": "Your device time",
  "wrong_device_time_check_again": "Check again",
  "wrong_device_time_close": "Close"
}
